export interface Currency {
  code: string;
  symbol: string;
  label: string;
  tag?: string;
}

export const CURRENCIES: Currency[] = [
  { code: "QAR", symbol: "﷼", label: "Qatari Riyal", tag: "QA" },
  { code: "AED", symbol: "د.إ", label: "UAE Dirham", tag: "AE" },
  { code: "BHD", symbol: "د.ب", label: "Bahraini Dinar", tag: "BH" },
  { code: "KWD", symbol: "د.ك", label: "Kuwaiti Dinar", tag: "KW" },

  //Client Requirement: UAE , Oman, Bahrain , Kuwait , KSA and Qatar so commented
  // { code: "EUR", symbol: "€", label: "Euro" },
  // { code: "SAR", symbol: "﷼", label: "Saudi Riyal" },
  // { code: "USD", symbol: "$", label: "US Dollar" },
  // { code: "JPY", symbol: "¥", label: "Japanese Yen" },
  // { code: "GBP", symbol: "£", label: "British Pound" },
  { code: "INR", symbol: "₹", label: "Indian Rupee", tag: "IN" },

  // Newly added / enabled
  { code: "SAR", symbol: "﷼", label: "Saudi Riyal", tag: "SA" }, // KSA
  { code: "OMR", symbol: "ر.ع.", label: "Omani Rial", tag: "OM" }, // Oman
];
